export default [
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
	{
		name: 'Jeremy Palmer',
		gender: 'Male',
		age: 31,
		visits: 4,
		text: 'Yes',
		created_at: '01-02-99',
		last_login: '01-02-99',
		spent: '$106.58'
	},
]



/** WEBPACK FOOTER **
 ** ./src/helpers/tempMembers.js
 **/